/**
 *
 * PriceSheetMethodPicker
 *
 */

import {
  BaseOptionsPicker,
  BaseOptionsPickerProps,
} from 'app/components/BasicPickers/BaseOptionsPicker';
import { PriceSheetBy } from 'enums/enums';
import { Entity } from 'types/common';
import { enumToEntityArray } from 'utils/enumKeys';

export interface PriceSheetMethodPickerProps
  extends Omit<BaseOptionsPickerProps<Entity<number>>, 'getOptions'> {}

export const getSinglePriceSheetMethod = (val: number): Entity<number> => {
  return enumToEntityArray(PriceSheetBy).filter(item => {
    return item.Id === val;
  })[0];
};

export const PriceSheetMethodData = (
  initval: number | string | undefined,
): Promise<Entity<number>[]> => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve(
        enumToEntityArray(PriceSheetBy).filter(item => {
          return item.Id.toString() === initval;
        }),
      );
    });
  }
};

const getOptions = (searchTerm: string | null) => {
  let items = enumToEntityArray(PriceSheetBy);
  if (searchTerm !== null && searchTerm !== '') {
    return items.filter(
      f => f.Name.startsWith(searchTerm) || f.Name.indexOf(searchTerm) !== -1,
    );
  }
  return items;
};

export function PriceSheetMethodPicker(props: PriceSheetMethodPickerProps) {
  return (
    <BaseOptionsPicker
      mini={props.mini ? true : undefined}
      size={props.size}
      getOptions={getOptions}
      value={props.value}
      {...props}
    />
  );
}
